import React from 'react';

import styles from './styles.module.css';

function GestorFood() {
    return (
        <section>
            <div className={styles.container}>
                <h1>Termos de uso</h1>
                <p>
                    Por favor, leia com atenção os termos e condições.<br/><br/>
                    Ao se cadastrar no Gestor Food você ESTÁ DE ACORDO COM AS CONDIÇÕES E TERMOS estabelecidos. 
                    E permite o armazenamento dos dados necessários para contemplar a relação (maiores informações sobre 
                    os dados, por favor, consultar a politica de privacidade). Note que a recusa destes Termos do Website 
                    impedirá que você utilize algumas funções do aplicativo.
                </p>
                
                <h2>1. Serviços oferecidos</h2>
                <p>
                    1.1 Este TERMO se aplica para regular o uso do serviço oferecido pelo Gestor Food aos USUÁRIOS, 
                    qual seja, possibilitar que USUÁRIOS acessem os dados de produtos da empresa e executem algumas 
                    funções de comanda para garçõns.
                    <br/><br/>
                    1.2 O serviço do Gestor Food consiste, portanto, em automatizar o processo de comanda de consumo 
                    de clientes através do software Gestor PDV, possibilitando que os USUÁRIOS executem certas funções 
                    agilizando o fluxo de trabalho.

                </p>

                <h2>2. Cadastro</h2>
                <p>
                    2.1 O USUÁRIO, para utilizar os serviços acima descritos, deverá possuir a licensa e uso do Gestor PDV 
                    e Gestores, assim criando um perfil de usuário e podendo utilizar as funções descritas acima.
                    <br/><br/>
                    2.2 Efetuado com sucesso o CADASTRO, o USUÁRIO terá acesso aos serviços por meio de login e senha, dados 
                    esses que se compromete a não divulgar a terceiros, ficando sob sua exclusiva responsabilidade qualquer 
                    solicitação de serviço que seja feita com o uso de login e senha de sua titularidade.

                </p>
                
                <h2>3. Obrigações do usuário</h2>
                <p>
                    3.1 Efetuado com sucesso o CADASTRO, o USUÁRIO se obriga a não divulgar a terceiros login e senha de acesso, 
                    nem permitir o uso de tais informações por terceiros, responsabilizando-se pelas consequências do uso de 
                    login e senha de sua titularidade.
                    <br/><br/>
                    3.2 É obrigação do USUÁRIO fornecer as permissões necessárias para o funcionamento do aplicativo.

                </p>

                <h2>4. Obrigações do Gestor Food</h2>
                <p>
                    4.1 Disponibilizar espaço virtual que permita ao USUÁRIO executar as funções de axilio de comanda ao garçon.
                    <br/><br/>
                    4.2 Proteger, por meio de armazenamento a confidencialidade de todas as informações e cadastros relativos aos 
                    USUÁRIOS. Contudo, não responderá pela reparação de prejuízos que possam ser derivados de apreensão e 
                    cooptação de dados por parte de terceiros que, rompendo os sistemas de segurança, consigam acessar essas 
                    informações.
                </p>

                <h2>5. Modificações deste termo</h2>
                <p>
                    5.1 O presente TERMO DE USO poderá, a qualquer tempo, ter seu conteúdo, ou parte dele, modificados para 
                    adequações e inserções, tudo com vistas ao aprimoramento dos serviços disponibilizados.
                </p> 

                <h2>6. Permissões obrigatórias</h2>
                <ul>
                    <li>INTERNET</li>
                    <li>ACCESS_COARSE_LOCATION</li>
                    <li>READ_PHONE_STATE</li>
                    <li>CHANGE_WIFI_STATE</li>
                    <li>ACCESS_WIFI_STATE</li>
                    <li>ACCESS_FINE_LOCATION</li>
                    <li>CAMERA</li>
                    <li>VIBRATE</li>
                    <li>WRITE_EXTERNAL_STORAGE</li>
                </ul>

                <h2>7. Aceitação do termo de uso</h2>
                <p>
                    7.1 O USUÁRIO declara ter lido, entendido e que aceita todas as regras, condições e obrigações estabelecidas no presente TERMO.
                </p> 
            </div>
        </section>
    )
}

export default GestorFood;